<template>
  <page-header-wrapper>
    <a-card :bordered="false" class="ant-pro-components-tag-select">
      <a-form layout="horizontal">
        <standard-form-row block>
          <div class="ant-pro-page-header-search">
            <a-input-search
              size="large"
              style="width: 80%; max-width: 522px;"
              v-model="params.where.nickname"
              placeholder="请输入要搜索的用户昵称"
              enter-button
              @search="getLists()"
            />
            <a-button
              type="link"
              @click="() => (this.search = !this.search)"
            >高级筛选<a-icon
              :type="search ? 'up' : 'down'"
            /></a-button>
          </div>
        </standard-form-row>
        <template v-if="search">
          <a-row :gutter="48">
            <a-col :md="12" :lg="8" :sm="24">
              <a-form-item label="真实姓名">
                <a-input
                  v-model="params.where.real_name"
                  placeholder="请输入要搜索的真实姓名"
                  allow-clear
                  @pressEnter="getLists()"
                />
              </a-form-item>
            </a-col>
            <a-col :md="12" :lg="8" :sm="24">
              <a-form-item label="联系电话">
                <a-input
                  v-model="params.where.phone"
                  placeholder="请输入要搜索的用户联系电话"
                  allow-clear
                  @pressEnter="getLists()"
                />
              </a-form-item>
            </a-col>
            <a-col :md="12" :lg="8" :sm="24">
              <a-form-item label="邮箱">
                <a-input
                  v-model="params.where.email"
                  placeholder="请输入要搜索的用户邮箱"
                  allow-clear
                  @pressEnter="getLists()"
                />
              </a-form-item>
            </a-col>
            <a-col :md="12" :lg="8" :sm="24">
              <a-form-item label="创建日期">
                <a-range-picker
                  :ranges="{
                    最近七天: [moment().subtract('days', 6), moment()],
                    今天: [moment(), moment()],
                    本月: [moment().startOf('month'), moment()]
                  }"
                  :placeholder="['开始日期', '结束日期']"
                  @change="values => handleChangeDate(values)"
                />
              </a-form-item>
            </a-col>
            <!--    <a-col :md="8" :sm="24">
              <a-form-item label="是否官方">
                <a-radio-group v-model="params.where.official" @change="getLists()">
                  <a-radio-button value="1">
                    是
                  </a-radio-button>
                  <a-radio-button value="2">
                    否
                  </a-radio-button>
                </a-radio-group>
              </a-form-item>
            </a-col> -->
            <!--   <a-col :md="12" :sm="24">
              <a-form-item label="会员类型">
                <a-radio-group v-model="params.where.type" @change="getLists()">
                  <a-radio-button value="1">
                    普通会员
                  </a-radio-button>
                  <a-radio-button value="2">
                    教师
                  </a-radio-button>
                  <a-radio-button value="3">
                    机构
                  </a-radio-button>
                </a-radio-group>
              </a-form-item>
            </a-col> -->
          </a-row>
        </template>
      </a-form>
    </a-card>

    <a-card style="margin-top: 24px;" :bordered="false" title="用户列表">
      <div slot="extra" class="d-flex change-state">
        <table-tool-bar-list
          :columns="settingColumns"
          :element="element"
          @change="toolBarChange"
          @reload="getLists()"
        />
        <export
          :columns="columns"
          :params="params"
          :url="apiList.getList"
          xlsxName="用户列表"
          v-action:export
          @click="getExportData"
        />
        <a-select
          allow-clear
          placeholder="请选择认证状态"
          v-model="params.where.real_auth"
          style="width: 120px"
          @change="getLists()"
        >
          <a-select-option value="">全部</a-select-option>
          <a-select-option value="1">已认证</a-select-option>
          <a-select-option value="2">未认证</a-select-option>
          <a-select-option value="3">待审核</a-select-option>
          <a-select-option value="4">已驳回</a-select-option>
        </a-select>
      </div>
      <a-table
        class="screenfull"
        :columns="columns"
        :data-source="list"
        :rowKey="record => record.id"
        :pagination="pagination"
        :loading="loading"
        @change="handleTableChange"
        :size="size"
        :bordered="false"
        :scroll="scroll"
      >
        <template slot="real_auth" slot-scope="text">
          <a-badge :color="getRealAuthMap(text).color" :text="getRealAuthMap(text).value" />
        </template>
        <template slot="official" slot-scope="text">
          <span :style="{ color: text === 1 ? 'green' : 'red' }">{{ text === 1 ? '是' : '否' }}</span>
        </template>
        <template slot="sex" slot-scope="text">
          {{ text | sexMap }}
        </template>
        <template slot="type" slot-scope="text">
          <a-badge :color="getTypeMap(text).color" :text="getTypeMap(text).value" />
        </template>
        <template slot="state" slot-scope="text, record">
          <a-switch :checked="record.state === 1" @change="handleChangeState(record.id)" v-action:state>
            <a-icon slot="checkedChildren" type="check" />
            <a-icon slot="unCheckedChildren" type="close" />
          </a-switch>
        </template>
        <template slot="operation" slot-scope="text, record">
          <a @click="handleDetailShow(record, '2')" v-action:real>去认证</a>
          <a-divider type="vertical" v-action:real />
          <a @click="handleDetailShow(record, '1')">查看详情</a>
        </template>
      </a-table>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { list, table } from '@/mixins' // 引入
import { StandardFormRow, TableToolBarList, Export } from '@/components'
import { ModelDetail } from './modules'

const columns = [
    {
        title: 'ID',
        dataIndex: 'id',
        sorter: true
    },
    {
        title: '昵称',
        dataIndex: 'nickname'
    },
    {
        title: '性别',
        dataIndex: 'sex',
        align: 'center',
        scopedSlots: { customRender: 'sex' }
    },
    {
        title: '联系电话',
        dataIndex: 'phone',
        sorter: true
    },
    {
        title: '创建时间',
        dataIndex: 'created_at',
        sorter: true
    },
    {
        title: '状态',
        dataIndex: 'state',
        align: 'center',
        fixed: 'right',
        scopedSlots: { customRender: 'state' }
    }
]
const apiList = {
    getList: '/members',
    changeState: '/members/'
}

export default {
    name: 'MembersList',
    mixins: [list, table], // 使用mixins
    components: {
        ModelDetail,
        StandardFormRow,
        TableToolBarList,
        Export
    },
    data () {
        return {
            apiList,
            columns,
            settingColumns: JSON.parse(JSON.stringify(columns)) // 深度复制表头
        }
    },
    computed: {
        getTypeMap (status) {
            return function (status) {
                const statusMap = {
                    1: { value: '普通会员', color: 'gold' },
                    2: { value: '教师', color: '#f50' },
                    3: { value: '机构', color: 'green' }
                }
                return statusMap[status]
            }
        },
        getRealAuthMap (status) {
            return function (status) {
                const statusMap = {
                    1: { value: '已认证', color: 'green' },
                    2: { value: '未认证', color: '#eee' },
                    3: { value: '待审核', color: 'gold' },
                    4: { value: '已驳回', color: '#f50' }
                }
                return statusMap[status]
            }
        }
    },
    mounted () {
        this.params.where.real_auth = '' // 认证状态默认全部
        this.getLists() // 获取广告位列表
    },
    methods: {
        /**
         * 获取打印数据
         * @jdy
         *newColumns,data
         * @2020-11-30
         */
        getExportData (columns, data) {
            data.filter(item => {
                item.real_auth = this.getRealAuthMap(item.real_auth).value
                item.official = item.official === 1 ? '是' : '否'
                item.sex = this.$options.filters['sexMap'](item.sex)
                item.type = this.getTypeMap(item.type).value
                item.state = item.state === 1 ? '使用中' : '禁用'
            })
            this.outputXlsxFile(columns, data, '**用户列表' + this.moment(new Date()).format('YYYYMMDDHHmmss'))
        },
        /**
         * 修改官方人员状态
         * @jdy
         * @2021-1-13
         */

        /**
         * 弹窗展示
         *
         * @params
         *record 用户数据
         * ModelDetail
         */
        handleDetailShow (record, type) {
            const that = this
            const getTypeMap = that.getTypeMap
            const getRealAuthMap = that.getRealAuthMap
            that.$dialog(
                ModelDetail,
                {
                    userinfo: record,
                    defaultKey: type,
                    getTypeMap,
                    getRealAuthMap,
                    on: {
                        ok () {
                            console.log('ok 回调')
                        },
                        cancel () {
                            console.log('cancel 回调')
                        },
                        close () {
                            console.log('modal close 回调')
                        }
                    }
                },
                // modal props
                {
                    title: '用户详情',
                    width: 700,
                    centered: true,
                    maskClosable: false
                }
            )
        }
    }
}
</script>

<style lang="less" scoped>
/deep/.ant-card-cover {
    div {
        text-align: center;
        img {
            width: 100%;
        }
    }
}
.button-color-success {
    background-color: #62ea9f;
    border-color: #62ea9f;
}
</style>
